import { forwardRef, type ReactNode } from "react";

/** Wraps a single page for the page-flip engine.
 *  - `data-density` is read by the engine and chooses the flip animation:
 *    "hard" → rotateY with backface-visibility:hidden (rigid board);
 *    "soft" → 2D clip-path curl.
 *  - `data-variant` only drives our own border styling and is independent
 *    of the engine. Portrait pages set density="hard" to avoid the engine's
 *    soft-curl rendering the same image on the underside of the fold, but
 *    interior pages still want the thin border, not the cover's heavy ink
 *    border — hence the split. */
type PageProps = {
  density?: "hard" | "soft";
  variant?: "cover" | "interior";
  children: ReactNode;
};

const Page = forwardRef<HTMLDivElement, PageProps>(function Page(
  { density = "soft", variant = "interior", children },
  ref,
) {
  return (
    <div
      ref={ref}
      className="tp-flipbook-page"
      data-density={density}
      data-variant={variant}
    >
      {children}
    </div>
  );
});

Page.displayName = "Page";

export default Page;
